<template>
<div class="category_container">
  <!-- 品类 -->
  <div class="category_item" v-for="(category, index) in subItems" :key="category.cateId">
    <!-- 不是all -->
    <div @click="$emit('tapCateId', category, index)" v-if="category.cateId !== '0'" :class="[selectedCateId === category.cateId ? 'selected' : '', 'title']">{{category.title}}</div>
    <!-- all -->
    <div @click="handleAll(category)" v-else class="title_all">
      <div class="title_in_all">{{category.title}}</div>
      <!-- <svg xmlns="http://www.w3.org/2000/svg" overflow="hidden" viewBox="0 0 48 48"><path fill-rule="nonzero" d="M4.44 16.561l15.878 16.12a4.5 4.5 0 0 0 6.364 0l15.879-16.12a1.5 1.5 0 0 0-2.122-2.122L24.561 30.56a1.5 1.5 0 0 1-2.122 0L6.561 14.44a1.5 1.5 0 1 0-2.122 2.121z"/></svg> -->
      <img src="https://img0.didiglobal.com/static/soda_public/do1_fk5ChuxCaXpqubhe2nHv" />
    </div>
    <!-- 占位 -->
    <div
    v-if="category.cateId === '0' && occupySubItemOfAll.cateId"
    :class="['selected', 'title']"
    >{{occupySubItemOfAll.title}}</div>
  </div>
  <!-- all里内容 -->
  <half-popup
    class="trending_food_half_popup"
    :title="allTitle"
    :isShow="isShow"
    @clickMask="clickMask"
    >
    <div class="content" slot="content">
      <div @click="tapOccupy(c)" class="item" v-for="(c, index) in allItems" :key="index">{{c.title}}</div>
    </div>
  </half-popup>
</div>
</template>
<script>
import HalfPopup from '@/components/half-popup/index'
import trackEvent from '@/common/js/track'
export default {
  props: {
    occupySubItemOfAll: {
      type: Object,
      default: () => ({}),
    },
    subItems: {
      type: Array,
      defalut: [],
    },
    selectedCateId: {
      type: String,
      default: ''
    }
  },
  components: {
    HalfPopup
  },
  data() {
    return {
      allTitle: '',
      allItems: [],
      isShow: false,
    }
  },
  computed: {},
  methods: {
    tapOccupy(c) {
      this.isShow = false;
      this.$emit('tapOccupy', c);
    },
    clickMask() {
      this.isShow = false;
    },
    handleAll(category) {
      this.allItems = category?.subItems?.items;
      this.allTitle = category?.title;
      this.$emit('traceAllItems', this.allItems)
      this.isShow = true;
    }
  }
}
</script>
<style lang="scss" scoped>
.category_container {
  width: 718px;
  padding-left: 32px;
  overflow-x: auto;
  display: flex;
  &::-webkit-scrollbar {
    display: none;
  }
  .category_item {
    display: flex;
    .title_all {
      margin-right: 20px;
      height: 72px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(255,255,255,0.50);
      border-radius: 18px;
      padding: 0 32px 0 32px;
      .title_in_all {
        font-family: DiDiSans-Pro-Medium;
        font-size: 24px;
        color: #975425;
        letter-spacing: 0;
        font-weight: 500;
        width: fit-content;
        white-space: nowrap;
      }
      img {
        margin-left: 9px;
        width: 24px;
        height: 24px;
        color: #975425;
      }
    }
    .title {
      margin-right: 20px;
      width: fit-content;
      height: 72px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(255,255,255,0.50);
      border-radius: 18px;
      padding: 0 32px 0 32px;
      font-family: DiDiSans-Pro-Medium;
      font-size: 24px;
      color: #975425;
      letter-spacing: 0;
      font-weight: 500;
    }
    .selected {
      background: #E1CFB4;
      border-radius: 18px;
      font-family: DiDiSans-Pro-Bold;
      font-size: 24px;
      color: #975425;
      letter-spacing: 0;
      font-weight: 700;
    }
  }
}
.trending_food_half_popup {
  background: #FAFAFA;
  .half-content {

  }
  .content {
    display: flex;
    flex-wrap: wrap;
    width: 730px;
    .item {
      margin-top: 32px;
      margin-right: 16px;
      width: fit-content;
      background: #FFFFFF;
      box-shadow: 0px 10px 40px 0px rgba(0,0,0,0.04);
      border-radius: 18px;
      padding: 20px 32px 20px 32px;
      font-family: DiDiSans-Pro-Medium;
      font-size: 28px;
      color: #000000;
      letter-spacing: 0;
      font-weight: 500;
    }
  }
}
</style>